/* ============================================================
   researchGate — TASK-331 owner finding (staging 2026-09-06): a user who
   skipped onboarding (Quick brand: name only; businessDescription/
   targetAudience still hold onboarding's placeholder strings) could open
   /app/research and click "Start market research" straight into a real
   (quota-consuming) run over empty brand input.

   Pure decision helper — no React, no network. Deliberately reuses the
   SAME brand-readiness rules the dashboard "Building your setup" card
   already uses (lib/activationProgress.js's missingBrandFields — itself a
   byte-for-byte mirror of packages/dathent-entitlements/src/brand-readiness.ts's
   strategyReady set — and lib/brandWorkspace.js's isBareWorkspace) instead
   of re-deriving brand completeness here, so ResearchTab.jsx's gate and the
   dashboard card can never drift apart on what counts as "ready".
   ============================================================ */
import { missingBrandFields } from './activationProgress.js';
import { isBareWorkspace } from './brandWorkspace.js';

/**
 * Whether starting (or retrying) a market-research run should be gated
 * behind a "finish your brand basics" empty state instead of firing a real
 * run at the research-worker.
 *
 * @param {object|null} profile  brand profile as ResearchTab already has it
 *        (toBrandForm-shaped: businessName, businessDescription,
 *        targetAudience, offer, productOrService, websiteUrl, …)
 * @returns {{ blocked: boolean, primary: 'onboarding'|'manual' }}
 *          `primary` names which CTA should be the PRIMARY action when
 *          blocked: 'onboarding' for a bare workspace (nothing to lose by
 *          sending them through the guided flow, website scan included),
 *          'manual' once some real content already exists (isBareWorkspace
 *          false) — matches decideActivationProgress's own empty-brand
 *          branch so the two surfaces never disagree.
 */
export function researchStartGate(profile) {
  const blocked = missingBrandFields(profile).length > 0;
  // Owner decision (2026-09-08): quick onboarding is the default path to a
  // ready brand everywhere (it also scans the website); the manual form is
  // always offered as the secondary link by the gate component.
  const primary = blocked ? 'onboarding' : (isBareWorkspace(profile) ? 'onboarding' : 'manual');
  return { blocked, primary };
}
